import { render, staticRenderFns } from "./Pettycashes.vue?vue&type=template&id=0f0c5114&"
import script from "./Pettycashes.vue?vue&type=script&lang=js&"
export * from "./Pettycashes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports